export class Avaliacao{
    aprovada: boolean;
    result_status: boolean;
    trabalho_id: number;
    send_status: boolean;
    usuario_id: number;
    Q1: number;
	q1_obs: string;
	Q2: number;
	q2_obs: string;
	Q3: number;
	q3_obs: string;
	Q4: number;
	q4_obs: string;
    Q5: number;
	q5_obs: string;
	Q6: number;
	q6_obs: string;
	Q7: number;
	q7_obs: string;
	Q8: number;
	q8_obs: string;
	Q9: number;
	q9_obs: string;
	Q10: number;
	q10_obs: string;
    Q11: number;
	q11_obs: string;
	Q12: number;
	q12_obs: string;
	Q13: number;
	q13_obs: string;
	Q14: number;
	q14_obs: string;
    motivo: string;
	motivo_texto: string;
    corrigir: boolean;
}



// WEBPACK FOOTER //
// ./src/app/avaliacao/avaliacao.ts